export const environment = {
    appVersion: require('../../package.json').version + '-dev',
    username: '',
    password: '',
    appID: 'aat_projektverwaltung',
};
